module.exports = "mutation ($id: ID!, $data: LeadUpdate!) {\n  LeadUpdate(id: $id, data: $data) {\n    id\n  }\n}\n"